// @flow
export const ACTIVE = 'status-active';
export const COMING_SOON = 'status-coming-soon';
export const LOST_DOG_PROFILE_SOURCE = 'wag-tag-lost-dog';
export const ATTRIBUTION_SOURCE = 'wag-tag';

export const WAG_TAG_PLAN_BASIC = 1;
export const WAG_TAG_PLAN_PREMIUM = 2;

export const AGE_PUPPY = 0;
export const AGE_YOUNG = 7;
export const AGE_ADULT = 13;
export const AGE_SENIOR = 85;
export const AGE_MAP = {
  [AGE_PUPPY]: 'Puppy',
  [AGE_YOUNG]: 'Young',
  [AGE_ADULT]: 'Adult',
  [AGE_SENIOR]: 'Senior',
};

export const STERILE_MAYBE_NEUTERED = -1;
export const STERILE_NEUTERED = 1;
export const STERILE_NOT_NEUTERED = 0;
export const STERILE_MAP = {
  [STERILE_MAYBE_NEUTERED]: 'May or may not be neutered',
  [STERILE_NEUTERED]: 'Neutered',
  [STERILE_NOT_NEUTERED]: 'Not neutered',
};

// NOTE Adjust is smart enough to determine the client and which store we should
// be redirected to. In order to protect the code base in the case we move
// away from adjust, these links just need to be updated in 1 place.
export const IOS_APP_STORE_URL = 'https://app.adjust.com/dsdm1mn?url=sulink';
export const ANDROID_APP_STORE_URL = 'https://app.adjust.com/dsdm1mn';
export const REGISTRATION_SUCCESS_APP_URL = 'https://app.adjust.com/ua7q2ir?fallback=https%3A%2F%2Fapp.wagwalking.com%2F%3Futm_source%3Dwag_tag_registration%26utm_medium%3Dweb%26utm_campaign%3Dwag_tag';

export const REGEX_DATE = /^[\d]{2}\/[\d]{2}\/[\d]{4}$/;
export const REGEX_PHONE = /^\([\d]{2,3}\)\s[\d]{3}-[\d]{4}/;
/**
 * Minumum password requirement
 * 8 Characters, 1 Letter, 1 Number
 */
export const REGEX_MIN_PASSWORD = /^.*(?=.{8,})(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).*$/;

export const MOBILE_APP_VERSION_FORCE_UPDATE = '3.12.0';

export const WAG_TAG_EMAIL = 'wagtags@wagwalking.com';
export const PLAN_COMPLETE_NAME = 'Wag! Tag Complete';
export const CUSTOMER_SUPPORT_NUMBER = '1-(628)-400-4426';

export const SOURCE_ACTIVATION_FLOW_BUNDLE = 'bundle';

export const PASSWORD_MIN_CHARS = 8;
export const FREE_TRIAL_30_DAYS = 30;
export const FREE_TRIAL_60_DAYS = 60;
export const FREE_TRIAL_90_DAYS = 90;
